import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Course, CourseShort, getCourse, getCourses } from "../backend/courses";
import CourseHQs from "../components/courses/CourseHQs";
import CourseInfo from "../components/courses/CourseInfo";
import CoursePayment from "../components/courses/CoursePayment";
import CourseSuggests from "../components/courses/CourseSuggests";
import CourseSummary from "../components/courses/CourseSummary";
import Loading from "../components/_main/Loading";
import BannerTemplate from "../templates/BannerTemplate";
import './styles/Course.css'
import { Carousel } from "react-responsive-carousel";

function VC_Course() {
    const { courseid } = useParams();
    const [course, setCourse] = useState<Course>();
    const [otherCourses, setOtherCourses] = useState<CourseShort[]>([]);
    const [done, setDone] = useState(false);
    const [additionalDone, setAdditionalDone] = useState(false);
    const downloadCourse = async (id: string) => {
        const downloadedCourse = await getCourse(id);
        window.document.title = downloadedCourse.title || "Curso Virtual Campus";
        setCourse(downloadedCourse);
        setDone(true);
    }
    const dowloadAdditionalData =async () => {
        setOtherCourses(await getCourses());
        setAdditionalDone(true);
    }
    useEffect(() => {
        if (courseid) {
            if (!done) downloadCourse(courseid);
            if (!additionalDone) dowloadAdditionalData();
        }
    }, [courseid]);
    return (
        <>
            <BannerTemplate src={course?.banner || "/img/banner-page-cursos.jpg"}/>
            {(done) ? (courseid) ? (<>
                <CourseSummary course={course}/>
                <CourseHQs course={course!}/>
                <CourseInfo course={course}/>
                <img src={process.env.PUBLIC_URL + "/img/fellowship.jpg"} alt="" />
                {/*{course && <CoursePayment course={course}/>}*/}
                <CourseSuggests setCourse={setCourse} courses={otherCourses} done={additionalDone} setDone={setDone}/>
            </>) : <></>
            : <Loading/>}
            { (courseid === "do5ovvE39ya2HXJ7n6jN" || courseid === "6OGx0uSWXUXBAQG9chpS") && (
                <Carousel className='carousel-slides'  showThumbs={false} showStatus={false} infiniteLoop autoPlay interval={5000} >
                {
                    Array.from({ length: 14 }, (_, index) => ( <img key={index} src={`/img/sliders-congreso/Congreso MFM ${index + 1}.jpg`} alt={`slide-${index + 1}`} />))
                }
                </Carousel>
            ) }
        </>
    );
}

export default VC_Course;